<template>
  <div
    class="fixed bottom-6 inset-x-0 z-50 flex items-end justify-center px-4 pointer-events-none"
    dir="rtl"
  >
    <div
      class="relative w-full max-w-[384px] rounded shadow-popup text-white text-center pointer-events-auto"
      style="background: linear-gradient(180deg, #3f238b 0%, #18054b 100%)"
    >
      <!-- Close button -->
      <button
        class="absolute top-3 left-3 w-8 h-8 flex items-center justify-center text-white/80 hover:text-white"
        @click="handleDismiss"
        aria-label="סגור"
      >
        <span class="material-symbols-rounded text-xl">close</span>
      </button>

      <!-- Content -->
      <div class="px-10 pt-10 pb-8 flex flex-col items-center gap-4">
        <!-- Icon/Image circle -->
        <div
          class="w-[90px] h-[90px] rounded-full flex items-center justify-center overflow-hidden flex-shrink-0"
          style="background-color: #573c9d"
        >
          <img
            v-if="imageUrl"
            :src="imageUrl"
            :alt="popupTitle"
            class="w-full h-full object-cover"
          />
        </div>

        <!-- Texts -->
        <div class="flex flex-col gap-1">
          <p class="text-sm font-normal opacity-70">{{ popupTitle }}</p>
          <p class="text-2xl font-bold leading-snug">{{ popupText }}</p>
        </div>

        <!-- CTA button -->
        <button
          class="mt-2 bg-secondary-300 text-secondary-600 font-bold text-base px-10 py-3 rounded"
          @click="handleClick"
        >
          למעבר לסקר
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PollPopup",
  props: {
    popupImage: {
      type: String,
      default: null,
    },
    popupTitle: {
      type: String,
      default: "",
    },
    popupText: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      required: true,
    },
  },
  emits: ["dismiss"],
  computed: {
    imageUrl() {
      return this.popupImage
        ? `https://images.mishnatyosef.org/${this.popupImage}`
        : null;
    },
  },
  methods: {
    handleClick() {
      window.open(this.url, "_blank");
      this.$emit("dismiss");
    },
    handleDismiss() {
      this.$emit("dismiss");
    },
  },
};
</script>
